(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"] && !Shopify.designMode) return;
  try {
    
  class GlobalAlert extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.dismissButton = this.querySelector('[data-announcement-dismiss]');
      this.dismissKey = this.dataset.dismissKey;
      this.isDismissible = this.dataset.dismissible === 'true';

      if (!this.dismissKey || !this.isDismissible) return;

      try {
        if (window.localStorage.getItem(this.dismissKey) === 'true') {
          this.hidden = true;
          return;
        }
      } catch (error) {
        console.warn('Unable to read dismissed announcement state from localStorage.', error);
      }

      if (!this.dismissButton) return;

      this.dismissButton.addEventListener('click', () => {
        this.hidden = true;

        try {
          window.localStorage.setItem(this.dismissKey, 'true');
        } catch (error) {
          console.warn('Unable to persist dismissed announcement state to localStorage.', error);
        }
      });
    }
  }

  customElements.define('global-alert', GlobalAlert);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteMenu extends HTMLElement {
    connectedCallback() {
      this.menuToggle = this.querySelector('.mobile-menu-toggle');
      this.menu = this.querySelector('.mobile-menu');
      this.menuBackdrop = this.querySelector('.mobile-menu-backdrop');
      this.submenuToggles = [...this.querySelectorAll('.mobile-submenu-toggle')];

      this.handleToggleClick = () => {
        if (this.isMenuOpen()) {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      };

      this.handleBackdropClick = () => {
        this.closeMenu();
      };

      this.handleDocumentClick = (event) => {
        if (!this.isMenuOpen()) {
          return;
        }

        if (!this.menuToggle.contains(event.target) && !this.menu.contains(event.target)) {
          this.closeMenu();
        }
      };

      this.handleDocumentKeydown = (event) => {
        if (event.key === 'Escape' && this.isMenuOpen()) {
          this.closeMenu();
        }
      };

      this.handleResize = () => {
        this.syncMobileGeometry();

        if (window.innerWidth >= 1024 && this.isMenuOpen()) {
          this.closeMenu();
        }
      };

      this.handleSubmenuClick = (event) => {
        const toggle = event.currentTarget;
        const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
        const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

        toggle.setAttribute('aria-expanded', String(!isExpanded));
        submenu.hidden = isExpanded;
        submenu.setAttribute('aria-hidden', String(isExpanded));
      };

      this.menuToggle.addEventListener('click', this.handleToggleClick);
      this.menuBackdrop.addEventListener('click', this.handleBackdropClick);
      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keydown', this.handleDocumentKeydown);
      window.addEventListener('resize', this.handleResize);
      this.submenuToggles.forEach((toggle) => toggle.addEventListener('click', this.handleSubmenuClick));

      this.syncMobileGeometry();
    }

    disconnectedCallback() {
      this.menuToggle.removeEventListener('click', this.handleToggleClick);
      this.menuBackdrop.removeEventListener('click', this.handleBackdropClick);
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleDocumentKeydown);
      window.removeEventListener('resize', this.handleResize);
      this.submenuToggles.forEach((toggle) => toggle.removeEventListener('click', this.handleSubmenuClick));

      this.closeMenu();
    }

    isMenuOpen() {
      return this.menuToggle.getAttribute('aria-expanded') === 'true';
    }

    syncMobileGeometry() {
      const top = this.menu.getBoundingClientRect().top;
      const height = Math.max(0, window.innerHeight - top);

      this.menu.style.height = `${height}px`;
      this.menuBackdrop.style.top = `${top}px`;
      this.menuBackdrop.style.height = `${height}px`;
    }

    openMenu() {
      this.syncMobileGeometry();
      document.documentElement.style.overflowY = 'hidden';
      this.menuToggle.setAttribute('aria-expanded', 'true');
      this.menu.setAttribute('aria-hidden', 'false');
    }

    closeMenu() {
      if (this.menu.contains(document.activeElement)) {
        this.menuToggle.focus();
      }

      document.documentElement.style.overflowY = '';
      this.menuToggle.setAttribute('aria-expanded', 'false');
      this.menu.setAttribute('aria-hidden', 'true');

      this.submenuToggles.forEach((toggle) => {
        const submenu = document.getElementById(toggle.getAttribute('aria-controls'));
        toggle.setAttribute('aria-expanded', 'false');
        submenu.hidden = true;
        submenu.setAttribute('aria-hidden', 'true');
      });
    }
  }

  customElements.define('site-menu', SiteMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["locations-map"] && !Shopify.designMode) return;
  try {
    
  class LocationsMap extends HTMLElement {
    static mapboxPromise = null;

    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.map = null;
      this.mapToken = this.dataset.mapboxToken || '';
      this.pinIconUrl = this.dataset.pinIconUrl || '';
      this.locations = [];
      this.referenceCoordinates = null;
      this.selectedLocationId = null;
      this.previewLocationId = null;
      this.storageKey = 'pawsprings-selected-location';

      this.cacheElements();
      this.collectLocations();

      if (!this.locations.length) return;

      this.sortLocationsAlphabetically();
      this.renderLocations();
      this.bindEvents();

      const initialLocation = this.getInitialSelectedLocation();
      if (initialLocation) {
        this.setSelectedLocation(initialLocation.id, { flyTo: false, openPopup: false, persist: false });
      }
      this.initMapIfPossible().finally(() => {
        this.initializeReferenceLocation();
      });
    }

    cacheElements() {
      this.searchForm = this.querySelector('.js-location-search-form');
      this.searchInput = this.querySelector('.js-location-search-input');
      this.useCurrentLocationButton = this.querySelector('.js-location-use-current');
      this.statusElement = this.querySelector('.js-location-status');
      this.resultsSummaryElement = this.querySelector('.js-location-results-summary');
      this.cardsContainer = this.querySelector('.js-location-list');
      this.mapElement = this.querySelector('.js-location-map');
    }

    collectLocations() {
      this.locations = Array.from(this.querySelectorAll('.js-location-card')).map((element, index) => {
        const lat = parseFloat(element.dataset.lat || '');
        const lng = parseFloat(element.dataset.lng || '');

        return {
          id: element.dataset.locationId || 'location-' + String(index + 1),
          name: element.dataset.name || '',
          fullAddress: element.dataset.address || '',
          lat: Number.isFinite(lat) ? lat : null,
          lng: Number.isFinite(lng) ? lng : null,
          distance: null,
          element,
          markerElement: null,
          popup: null,
        };
      });
    }

    async initMapIfPossible() {
      if (!this.mapElement) return;

      if (!this.mapToken) {
        this.showStatus('Add a Mapbox public token in theme settings to enable the map.', true);
        this.renderMapFallback('Map unavailable until a Mapbox public token is configured.');
        return;
      }

      await this.resolveLocationCoordinates();

      if (!this.locationsWithCoordinates().length) {
        this.showStatus(
          'We could not place any locations on the map yet. Check the metaobject address fields or add coordinates.',
          true,
        );
        this.renderMapFallback('Map unavailable until at least one location can be geocoded.');
        return;
      }

      try {
        await this.loadMapboxResources();
        this.initMap();

        if (!this.map.loaded()) {
          await new Promise((resolve) => this.map.once('load', resolve));
        }

        this.addMarkers();
        this.fitMapToLocations();
        this.renderLocationStates();
      } catch (error) {
        console.error(error);
        this.showStatus('We could not load the map right now, but the locations list is still available.', true);
        this.renderMapFallback('Map unavailable right now.');
      }
    }

    async loadMapboxResources() {
      if (!document.querySelector('link[data-mapbox-gl]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.css';
        link.dataset.mapboxGl = 'true';
        document.head.appendChild(link);
      }

      if (window.mapboxgl) return;

      if (!LocationsMap.mapboxPromise) {
        LocationsMap.mapboxPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://api.mapbox.com/mapbox-gl-js/v2.15.0/mapbox-gl.js';
          script.async = true;
          script.dataset.mapboxGl = 'true';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
      }

      await LocationsMap.mapboxPromise;
    }

    initMap() {
      mapboxgl.accessToken = this.mapToken;
      this.map = new mapboxgl.Map({
        container: this.mapElement,
        style: 'mapbox://styles/mapbox/streets-v12',
        center: [-77.9447, 34.2257],
        zoom: 10,
      });

      this.map.addControl(new mapboxgl.NavigationControl({ showCompass: false }), 'top-right');
    }

    createPopup(location) {
      if (!window.mapboxgl || !location.element) return null;

      const clone = location.element.cloneNode(true);
      clone.classList.remove(
        'js-location-card',
        'shadow-panel',
        'shadow-panel-d',
        '-translate-y-0.5',
        'hover:-translate-y-0.5',
        'hover:shadow-panel-d',
      );
      clone.classList.add('shadow-none');
      clone.style.transform = 'none';
      clone.style.borderColor = 'var(--color-border)';

      return new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: true,
        maxWidth: '24rem',
        offset: 28,
      }).setDOMContent(clone);
    }

    addMarkers() {
      this.locationsWithCoordinates().forEach((location) => {
        const markerElement = document.createElement('button');
        markerElement.type = 'button';
        markerElement.className =
          'flex h-10 w-10 cursor-pointer items-center justify-center rounded-full border border-white bg-white transition-transform duration-200';
        markerElement.setAttribute('aria-label', 'Select ' + location.name);
        markerElement.style.boxShadow = '0 4px 14px rgba(0, 0, 0, 0.14)';
        markerElement.innerHTML = '<img src="' + this.escapeHtml(this.pinIconUrl) + '" alt="" class="h-5 w-5">';

        const marker = new mapboxgl.Marker({ element: markerElement, anchor: 'bottom' })
          .setLngLat([location.lng, location.lat])
          .addTo(this.map);

        location.marker = marker;
        location.markerElement = markerElement;
        location.popup = this.createPopup(location);

        markerElement.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.setSelectedLocation(location.id, { flyTo: true, scrollIntoView: true, openPopup: true });
        });
      });
    }

    bindEvents() {
      this.searchForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        this.handleSearch();
      });

      this.useCurrentLocationButton?.addEventListener('click', () => this.handleUseCurrentLocation());

      this.locations.forEach((location) => {
        location.element.addEventListener('click', (event) => {
          if (event.target.closest('a, button')) return;
          this.setSelectedLocation(location.id, { flyTo: true, openPopup: false });
        });

        location.element.addEventListener('mouseenter', () => {
          if (window.innerWidth < 768) return;
          this.previewLocationId = location.id;
          this.renderLocationStates();
        });

        location.element.addEventListener('mouseleave', () => {
          if (this.previewLocationId !== location.id) return;
          this.previewLocationId = null;
          this.renderLocationStates();
        });
      });
    }

    async handleSearch() {
      const query = this.searchInput?.value.trim();

      if (!query) {
        this.referenceCoordinates = null;
        this.locations.forEach((location) => {
          location.distance = null;
        });
        this.sortLocationsAlphabetically();
        this.renderLocations();
        this.showStatus('');
        if (this.map) this.fitMapToLocations();
        if (this.locations.length) {
          this.setSelectedLocation(this.locations[0].id, { flyTo: false, openPopup: false });
        }
        return;
      }

      if (!this.mapToken) {
        this.showStatus('Add a Mapbox public token in theme settings to search by city or ZIP.', true);
        return;
      }

      this.showStatus('Searching...');
      const coordinates = await this.geocode(query);

      if (!coordinates) {
        this.showStatus('Location not found. Please try a different city or ZIP.', true);
        return;
      }

      this.referenceCoordinates = coordinates;
      this.calculateDistances(coordinates);
      this.sortLocationsByDistance();
      this.renderLocations();
      this.showStatus('Sorted by distance from ' + query + '.');

      const nearestLocation = this.locations.find((location) => Number.isFinite(location.distance));
      if (nearestLocation) {
        this.setSelectedLocation(nearestLocation.id, { flyTo: false, openPopup: false });
      }

      if (this.map) {
        this.map.flyTo({ center: [coordinates.lng, coordinates.lat], zoom: 10, duration: 1200 });
      }
    }

    async initializeReferenceLocation() {
      if (!navigator.geolocation) return;

      const permissionState = await this.getGeolocationPermissionState();
      if (permissionState !== 'granted') return;

      try {
        const coordinates = await this.getCurrentCoordinates();
        this.applyReferenceCoordinates(coordinates, {
          flyTo: false,
        });
      } catch (error) {
        console.warn('Unable to automatically determine the current location.', error);
      }
    }

    async getGeolocationPermissionState() {
      if (!navigator.permissions?.query) return 'prompt';

      try {
        const permissionStatus = await navigator.permissions.query({ name: 'geolocation' });
        return permissionStatus.state;
      } catch (error) {
        console.warn('Unable to read geolocation permission state.', error);
        return 'prompt';
      }
    }

    getCurrentCoordinates() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject, {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 300000,
        });
      }).then((position) => ({
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      }));
    }

    applyReferenceCoordinates(coordinates, options = {}) {
      this.referenceCoordinates = coordinates;
      this.calculateDistances(coordinates);
      this.sortLocationsByDistance();
      this.renderLocations();

      if (options.statusMessage) {
        this.showStatus(options.statusMessage);
      }

      const nearestLocation = this.locations.find((location) => Number.isFinite(location.distance));
      if (nearestLocation) {
        this.setSelectedLocation(nearestLocation.id, { flyTo: false, openPopup: false });
      }

      if (options.flyTo && this.map) {
        this.map.flyTo({ center: [coordinates.lng, coordinates.lat], zoom: options.zoom || 11, duration: 1200 });
      }
    }

    async handleUseCurrentLocation() {
      if (!this.mapToken) {
        this.showStatus('Add a Mapbox public token in theme settings to use current location.', true);
        return;
      }

      if (!navigator.geolocation) {
        this.showStatus('Geolocation is not supported by this browser.', true);
        return;
      }

      this.showStatus('Getting your location...');

      try {
        const coordinates = await this.getCurrentCoordinates();
        this.applyReferenceCoordinates(coordinates, {
          statusMessage: 'Using your current location.',
          flyTo: true,
          zoom: 11,
        });
      } catch (error) {
        let message = 'We could not access your current location.';

        if (error && typeof error === 'object' && 'code' in error) {
          switch (error.code) {
            case error.PERMISSION_DENIED:
              message = 'Location access was blocked. Please allow it in your browser and try again.';
              break;
            case error.POSITION_UNAVAILABLE:
              message = 'Your location is unavailable right now. Please try again.';
              break;
            case error.TIMEOUT:
              message = 'The location request timed out. Please try again.';
              break;
          }
        }

        this.showStatus(message, true);
      }
    }

    async geocode(query) {
      if (!this.mapToken || !query) return null;

      try {
        const response = await fetch(
          'https://api.mapbox.com/geocoding/v5/mapbox.places/' +
            encodeURIComponent(query) +
            '.json?access_token=' +
            this.mapToken +
            '&country=US&types=address,postcode,place',
        );

        if (!response.ok) return null;

        const data = await response.json();
        const firstResult = (data.features || [])[0];
        if (!firstResult || !firstResult.center) return null;

        const lng = firstResult.center[0];
        const lat = firstResult.center[1];
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;

        return { lat, lng };
      } catch (error) {
        console.error(error);
        return null;
      }
    }

    async resolveLocationCoordinates() {
      const unresolvedLocations = this.locations.filter(
        (location) => (!Number.isFinite(location.lat) || !Number.isFinite(location.lng)) && location.fullAddress,
      );

      if (!unresolvedLocations.length) return;

      await Promise.all(
        unresolvedLocations.map(async (location) => {
          const coordinates = await this.geocode(location.fullAddress);
          if (!coordinates) return;
          location.lat = coordinates.lat;
          location.lng = coordinates.lng;
          location.element.dataset.lat = String(coordinates.lat);
          location.element.dataset.lng = String(coordinates.lng);
        }),
      );
    }

    calculateDistances(referenceCoordinates) {
      this.locations.forEach((location) => {
        if (!Number.isFinite(location.lat) || !Number.isFinite(location.lng)) {
          location.distance = null;
          return;
        }

        location.distance = this.calculateDistanceMiles(
          referenceCoordinates.lat,
          referenceCoordinates.lng,
          location.lat,
          location.lng,
        );
      });
    }

    calculateDistanceMiles(startLat, startLng, endLat, endLng) {
      const earthRadiusMiles = 3958.7613;
      const deltaLat = this.toRadians(endLat - startLat);
      const deltaLng = this.toRadians(endLng - startLng);
      const a =
        Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
        Math.cos(this.toRadians(startLat)) *
          Math.cos(this.toRadians(endLat)) *
          Math.sin(deltaLng / 2) *
          Math.sin(deltaLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return earthRadiusMiles * c;
    }

    toRadians(value) {
      return value * (Math.PI / 180);
    }

    sortLocationsAlphabetically() {
      this.locations.sort((left, right) => left.name.localeCompare(right.name));
    }

    sortLocationsByDistance() {
      this.locations.sort((left, right) => {
        if (left.distance === null && right.distance === null) return left.name.localeCompare(right.name);
        if (left.distance === null) return 1;
        if (right.distance === null) return -1;
        if (left.distance === right.distance) return left.name.localeCompare(right.name);
        return left.distance - right.distance;
      });
    }

    renderLocations() {
      if (!this.cardsContainer) return;

      this.locations.forEach((location) => {
        const distanceElement = location.element.querySelector('.js-location-distance');

        if (distanceElement) {
          if (location.distance === null) {
            distanceElement.textContent = '';
            distanceElement.classList.add('hidden');
          } else {
            distanceElement.textContent = this.formatDistance(location.distance);
            distanceElement.classList.remove('hidden');
          }
        }

        this.cardsContainer.appendChild(location.element);
      });

      this.updateResultsSummary();
      this.renderLocationStates();
    }

    formatDistance(distance) {
      if (distance < 1) return 'Less than 1 mile away';
      if (distance < 10) return distance.toFixed(1) + ' miles away';
      const rounded = Math.round(distance);
      return String(rounded) + ' ' + (rounded === 1 ? 'mile' : 'miles') + ' away';
    }

    updateResultsSummary() {
      if (!this.resultsSummaryElement) return;

      const count = this.locations.length;
      if (!count) {
        this.resultsSummaryElement.textContent = 'No locations configured yet.';
        return;
      }

      const noun = count === 1 ? 'Nearest Location' : 'Nearest Locations';
      this.resultsSummaryElement.textContent = String(count) + ' ' + noun;
    }

    getInitialSelectedLocation() {
      const storedSelection = this.readStoredSelection();
      if (!storedSelection?.id) return this.locations[0] || null;

      return this.locations.find((location) => location.id === storedSelection.id) || this.locations[0] || null;
    }

    readStoredSelection() {
      try {
        const storedSelection = window.localStorage.getItem(this.storageKey);
        return storedSelection ? JSON.parse(storedSelection) : null;
      } catch (error) {
        console.warn('Unable to read the saved location selection.', error);
        return null;
      }
    }

    persistSelectedLocation(location) {
      try {
        window.localStorage.setItem(
          this.storageKey,
          JSON.stringify({
            id: location.id,
            name: location.name,
            address: location.fullAddress,
          }),
        );
      } catch (error) {
        console.warn('Unable to save the selected location.', error);
      }
    }

    closeOtherPopups(selectedId) {
      this.locations.forEach((location) => {
        if (location.id === selectedId || !location.popup) return;
        location.popup.remove();
      });
    }

    setSelectedLocation(locationId, options = {}) {
      const location = this.locations.find((entry) => entry.id === locationId);
      if (!location) return;

      this.selectedLocationId = locationId;
      this.previewLocationId = null;
      this.renderLocationStates();
      this.closeOtherPopups(locationId);

      if (options.persist !== false) {
        this.persistSelectedLocation(location);
      }

      if (options.flyTo && this.map && Number.isFinite(location.lat) && Number.isFinite(location.lng)) {
        this.map.flyTo({ center: [location.lng, location.lat], zoom: 12, duration: 1000 });
      }

      if (options.scrollIntoView && location.element) {
        location.element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      if (
        options.openPopup &&
        this.map &&
        location.popup &&
        Number.isFinite(location.lat) &&
        Number.isFinite(location.lng)
      ) {
        location.popup.setLngLat([location.lng, location.lat]).addTo(this.map);
      }
    }

    renderLocationStates() {
      this.locations.forEach((location) => {
        const isSelected = location.id === this.selectedLocationId;
        const isPreviewed = location.id === this.previewLocationId;
        const isActive = isSelected || isPreviewed;

        location.element.classList.toggle('shadow-panel', !isActive);
        location.element.classList.toggle('shadow-panel-d', isActive);
        location.element.classList.toggle('-translate-y-0.5', isActive);
        location.element.style.borderColor = isActive ? 'var(--color-primary)' : '';

        if (location.markerElement) {
          location.markerElement.style.transform = isActive ? 'scale(1.08)' : 'scale(1)';
          location.markerElement.style.boxShadow = isActive
            ? '0 8px 24px rgba(0, 0, 0, 0.2)'
            : '0 4px 14px rgba(0, 0, 0, 0.14)';
        }
      });
    }

    fitMapToLocations() {
      if (!this.map || !this.locationsWithCoordinates().length) return;

      const bounds = new mapboxgl.LngLatBounds();
      this.locationsWithCoordinates().forEach((location) => {
        bounds.extend([location.lng, location.lat]);
      });

      this.map.fitBounds(bounds, { padding: window.innerWidth < 768 ? 32 : 60, maxZoom: 12 });
    }

    locationsWithCoordinates() {
      return this.locations.filter((location) => Number.isFinite(location.lat) && Number.isFinite(location.lng));
    }

    showStatus(message, isError = false) {
      if (!this.statusElement) return;
      this.statusElement.textContent = message;
      this.statusElement.classList.toggle('text-primary', isError);
      this.statusElement.classList.toggle('text-black/70', !isError);
    }

    renderMapFallback(message) {
      if (!this.mapElement) return;
      this.mapElement.innerHTML =
        '<div class="flex h-full min-h-[20rem] items-center justify-center p-6 text-center text-sm text-black/70">' +
        this.escapeHtml(message) +
        '</div>';
    }

    escapeHtml(value) {
      return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
  }

  if (!customElements.get('locations-map')) {
    customElements.define('locations-map', LocationsMap);
  }

  } catch(e) { console.error(e); }
})();
})();
